export default __webpack_public_path__ + "static/media/hht1_ep11_timeline_04.ffb5c47e.png";